import { Check } from "lucide-react";
import { QUALITY_OPTIONS } from "@/features/player/sourceLoader";

const SPEEDS = [0.5, 0.75, 1, 1.25, 1.5, 2];

const Group = ({ label, children }) => (
  <div className="py-2">
    <p className="px-4 pb-1 text-[0.68rem] font-bold uppercase tracking-[0.25em] text-[#D4AF37]">{label}</p>
    {children}
  </div>
);

const Option = ({ active, onClick, children, testId }) => (
  <button data-testid={testId} onClick={onClick} className={`flex w-full items-center justify-between px-4 py-2 text-sm transition-colors hover:bg-[#D4AF37]/10 ${active ? "text-[#FFD86A]" : "text-white/85"}`}>
    {children}
    {active && <Check className="h-4 w-4" />}
  </button>
);

export const SubtitleMenu = ({ tracks, active, onSelect }) => (
  <div data-testid="player-subtitle-menu" className="absolute bottom-14 right-0 w-56 rounded-xl glass bg-black/90 overflow-hidden">
    <Group label="Subtitles">
      <Option testId="subtitle-option-off" active={!active} onClick={() => onSelect(null)}>Off</Option>
      {tracks.map((t) => (
        <Option key={t.lang} testId={`subtitle-option-${t.lang}`} active={active === t.lang} onClick={() => onSelect(t.lang)}>{t.label}</Option>
      ))}
    </Group>
  </div>
);

export const SettingsMenu = ({ speed, onSpeed, quality, onQuality }) => (
  <div data-testid="player-settings-menu" className="absolute bottom-14 right-0 w-60 max-h-[60vh] overflow-y-auto rounded-xl glass bg-black/90">
    <Group label="Playback speed">
      {SPEEDS.map((s) => (
        <Option key={s} testId={`speed-option-${s}`} active={speed === s} onClick={() => onSpeed(s)}>{s === 1 ? "Normal" : `${s}x`}</Option>
      ))}
    </Group>
    <div className="gold-hairline" />
    <Group label="Quality">
      {QUALITY_OPTIONS.map((q) => (
        <Option key={q} testId={`quality-option-${q}`} active={quality === q} onClick={() => onQuality(q)}>{q}</Option>
      ))}
    </Group>
  </div>
);
